export let insetObject = {
	orderId: "",
	customerName: "",
	orderStatus: "",
	orderSource: "",
	createdDate: ""
}

export let tableHeader = [
	// {
	// 	text: "Id",
	// 	value: "customerGuid",
	// 	align: "left"
	// },
	{
		text: "Id",
		value: "configurationId",
		align: "left"
	},
	{
		text: "Meno",
		value: "name",
		align: "left"
	},
	{
		text: "Hodnota",
		value: "value",
		align: "left"
	},
	{
		text: "Popis",
		value: "description",
		align: "left"
	},
	{
		text: "",
		value: "action",
		sortable: false
	}
]